require('../base.js')

$(document).ready(function(){

	var window_width = $(window).width();
	var window_height = $(window).height();
require('../base.js')

$(document).ready(function(){

	var window_width = $(window).width();
	var window_height = $(window).height();


	if(window_width <= 768){
		var window_height_temp = parseInt(window_width / 2)+80;
		$(".showvideo_middle").css({width:window_width+"px",height:(window_height_temp)+"px",'background-color':'black'});
		$(".video_play").css({width:(window_width-80)+"px",height:(window_height_temp-80)+"px"});
		$(".video_content").css({width:(window_width-80)+"px",height:(window_height_temp-80)+"px"});

        $(".nar-bar").on("click", function () {
            window.open('http://metraweather.com/press/MetraWeather-and-BloomSky-join-forces-to-deliver-big-impacts-with-Small-Data-and-Sherlock%E2%84%A2', '_self');
        });
	}else{

		$(".showvideo_middle").css({width:880+"px",height:530+"px",'background-color':'#FFFFFF'});
		$(".video_play").css({width:800+"px",height:450+"px"});
		$(".video_content").css({width:800+"px",height:450+"px"});
	}

	$(window).resize(function() {
		var window_width = $(window).width();
		var window_height = $(window).height();


		if(window_width< 768){
			var window_height_temp = parseInt(window_width / 2)+80;
			// console.log("jjjj = ",window_height_temp);

			$(".showvideo_middle").css({width:window_width+"px",height:(window_height_temp)+"px",'background-color':'black'});
			$(".video_play").css({width:(window_width-80)+"px",height:(window_height_temp-80)+"px"});
			$(".video_content").css({width:(window_width-80)+"px",height:(window_height_temp-80)+"px"});

            $(".nar-bar").on("click", function () {
                window.open('http://metraweather.com/press/MetraWeather-and-BloomSky-join-forces-to-deliver-big-impacts-with-Small-Data-and-Sherlock%E2%84%A2', '_self');
            });
		}else{

			$(".showvideo_middle").css({width:880+"px",height:530+"px",'background-color':'#FFFFFF'});
			$(".video_play").css({width:800+"px",height:450+"px"});
			$(".video_content").css({width:800+"px",height:450+"px"});
		}

	});

  $(".youtube-video").on("click", function () {
  	    $(".video-player_youtube").attr('id',"visible");  　
  	    document.documentElement.style.overflowY = 'hidden';
  	    $(".showvideo_middle").attr('id',"visible");  　
  	    document.documentElement.style.overflowY = 'hidden';
  	    $('.video_content').attr('src','https://www.youtube.com/embed/mknvkoJtyVk?autoplay=1&controls=1&showinfo=0');

  });




  $(".widget-close-button").on("click", function () {
  	    $(".video-player_youtube").removeAttr('id');
  	    $(".showvideo_middle").removeAttr('id');
  	    document.documentElement.style.overflowY = 'visible';
  	    $('.video_content').attr('src','');
  });




});


	if(window_width <= 768){
		var window_height_temp = parseInt(window_width / 2)+80;
		$(".showvideo_middle").css({width:window_width+"px",height:(window_height_temp)+"px",'background-color':'black'});
		$(".video_play").css({width:(window_width-80)+"px",height:(window_height_temp-80)+"px"});
		$(".video_content").css({width:(window_width-80)+"px",height:(window_height_temp-80)+"px"});

        $(".nar-bar").on("click", function () {
            window.open('http://metraweather.com/press/MetraWeather-and-BloomSky-join-forces-to-deliver-big-impacts-with-Small-Data-and-Sherlock%E2%84%A2', '_self');
        });
	}else{

		$(".showvideo_middle").css({width:880+"px",height:530+"px",'background-color':'#FFFFFF'});
		$(".video_play").css({width:800+"px",height:450+"px"});
		$(".video_content").css({width:800+"px",height:450+"px"});
	}

	$(window).resize(function() {
		var window_width = $(window).width();
		var window_height = $(window).height();


		if(window_width< 768){
			var window_height_temp = parseInt(window_width / 2)+80;
			// console.log("jjjj = ",window_height_temp);

			$(".showvideo_middle").css({width:window_width+"px",height:(window_height_temp)+"px",'background-color':'black'});
			$(".video_play").css({width:(window_width-80)+"px",height:(window_height_temp-80)+"px"});
			$(".video_content").css({width:(window_width-80)+"px",height:(window_height_temp-80)+"px"});

            $(".nar-bar").on("click", function () {
                window.open('http://metraweather.com/press/MetraWeather-and-BloomSky-join-forces-to-deliver-big-impacts-with-Small-Data-and-Sherlock%E2%84%A2', '_self');
            });
		}else{

			$(".showvideo_middle").css({width:880+"px",height:530+"px",'background-color':'#FFFFFF'});
			$(".video_play").css({width:800+"px",height:450+"px"});
			$(".video_content").css({width:800+"px",height:450+"px"});
		}

	});

  $(".youtube-video").on("click", function () {
  	    $(".video-player_youtube").attr('id',"visible");  　
  	    document.documentElement.style.overflowY = 'hidden';
  	    $(".showvideo_middle").attr('id',"visible");  　
  	    document.documentElement.style.overflowY = 'hidden';
  	    $('.video_content').attr('src','https://www.youtube.com/embed/mknvkoJtyVk?autoplay=1&controls=1&showinfo=0');

  });




  $(".widget-close-button").on("click", function () {
  	    $(".video-player_youtube").removeAttr('id');
  	    $(".showvideo_middle").removeAttr('id');
  	    document.documentElement.style.overflowY = 'visible';
  	    $('.video_content').attr('src','');
  });




});



//////////////////
// WEBPACK FOOTER
// ./src/js/kickstarter_video.js
// module id = 0
// module chunks = 5